import {SnackBarMutation} from "./types";

export default {
    [SnackBarMutation.SET](state, {data, type}) {
        state.data = data;
        state.type = type;
    },
    [SnackBarMutation.SET_ACTIVE](state, active) {
        state.active = active;
    },
}